import styled from "styled-components/macro";
import { motion } from "framer-motion";

export const DivWelcomeText = styled(motion.div)<{ fontSize: number }>`
  font-family: ${(props) => props.theme.font.arialBlack};
  font-size: ${(props) => props.fontSize}rem;
  text-align: center;
`;
